import React from 'react';

export const Label: React.FC = (props) => {
  return (
    <label className="block text-xs font-semibold text-gray-600 uppercase">
      {props.children}
    </label>
  )
}